import { motion } from "framer-motion";
import * as Rebass from "rebass";

export default {
  Flex: motion.custom(Rebass.Flex),
  Box: motion.custom(Rebass.Box),
  Image: motion.custom(Rebass.Image),
  Text: motion.custom(Rebass.Text),
};
